import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CSSelectComponent } from 'src/app/shared/components/cs-select/cs-select.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { ToastService } from 'src/app/shared/service/toast.service';
import { UserAssetsService } from '../../user-asset/user-assets.service';
import { RedeemCodeComponent } from '../redeem-code/redeem-code.component';

@Component({
  selector: 'app-claim-bonus-by-currency',
  standalone: true,
  imports: [CSButtonComponent, CSIconButtonComponent, PipesModule, CSSelectComponent],
  templateUrl: './claim-bonus-by-currency.component.html',
  styleUrl: './claim-bonus-by-currency.component.scss',
})
export class ClaimBonusByCurrencyComponent implements OnInit {
  targetCurrency: string = 'USDT';
  targetAmount: number = 0;
  cryptoList: any[] = [];
  InjectItem: any;
  loading: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<RedeemCodeComponent>,
    private userAssetsService: UserAssetsService,
    @Inject(MAT_DIALOG_DATA) public data: { bonusData: any; cryptoCurrencies: any[] },
    private bonusApi: BonusApi,
    private toast: ToastService,
  ) {}

  ngOnInit() {
    this.InjectItem = JSON.parse(JSON.stringify(this.data.bonusData));
    this.cryptoList = this.data.cryptoCurrencies;
    this.targetCurrency = this.InjectItem.currency;
    this.targetAmount = this.InjectItem.amount || 0;
  }
  close() {
    this.dialogRef.close();
  }

  currencyChange() {
    console.log('Selected currency:', this.targetCurrency);
    this.getAllRateAndTranslation();
  }

  getAllRateAndTranslation() {
    const userbalance: any = this.userAssetsService.getRatesBaseCurrency(
      this.userAssetsService.allRate.value,
      this.targetCurrency,
    );
    const rate = userbalance.rates.find((x: any) => x.currency === this.InjectItem.currency)?.rate || 1;
    this.targetAmount = (this.InjectItem?.amount || 0) * rate;
  }

  claimBonus(item: any) {
    if (item.cardStatus === 'Unclaimed') {
      this.loading = true;

      this.bonusApi
        .getReceiveBackwater({ bonusId: item.id, collectedCurrency: this.targetCurrency })
        .pipe(map(v => v?.data))
        .subscribe(data => {
          if (data) {
            this.toast.show({
              title: 'Bonus Claimed',
              message: 'Your bonus was claimed successfully. Check your transaction history for details.',
              type: 'success',
            });
            this.dialogRef.close({ success: true });
          } else {
            this.toast.show({ title: 'Unknown error', message: 'Please try again', type: 'fail' });
          }
          this.loading = false;
        });
    }
  }
}
